import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import React, { useEffect } from 'react';
import { HttpStatusCode } from 'services/constants';
import { useGetServiceBootstrap } from 'services/hooks';
import { useActions } from 'state/store';

export const AppServiceBootStrap: React.FC = (): JSX.Element => {
  const { isLoading, error } = useGetServiceBootstrap();
  const { setShowFullLoadingView, setShowNoDataView } = useActions();

  useEffect(() => {
    if (!isLoading) {
      setShowFullLoadingView(false);
    }
    if (
      error &&
      (error as FetchBaseQueryError)?.status === HttpStatusCode.NOT_FOUND
    ) {
      setShowNoDataView(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, error]);
  return <></>;
};
